module.exports = __webpack_public_path__ + "img/4.fd61c632.jpg";